export default "__VITE_ASSET__BMWCOxxF__"